/* eslint-disable camelcase */

import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { api } from 'controllers/network/apiClient';

export interface Popup {
  id: number;
  name: string;
  font: string;
  custom_css: string | null;
  button_text: string;
  border_radius: number;
  button_radius: number;
  email_headline: string;
  background_style: string;
  email_close_text: string;
  two_touch_enabled: boolean;
  email_pre_headline: string;
  headline_font_size: number;
  email_post_headline: string;
  email_subscribe_text: string;
  welcome_message_text: string;
  collection_attributes: string[];
  disclaimer_text_color: string;
  post_headline_font_size: number;
  welcome_message_media_url: string;
  keyword_id: number | null;
  delay: number;
  logo_url: string;
  headline: string;
  pre_headline: string;
  post_headline: string;
  subscribe_text: string;
  close_text: string;
  bubble_text: string;
  background_color: string;
  text_color: string;
  button_background_color: string;
  button_text_color: string;
  sms_message: string;
  script_tag_id: null;
  enabled: boolean;
  popup_size: string;
  start_position: string;
  sub_headline: string;
  powered_by: string;
  background_image: null | string;
  countries_allowed: string;
  close_action: string;
  excluded_pages: string;
  included_pages: string;
  popup_type: string;
  phone_number_dict: Record<string, string>;
  updated_at: string;
  side_img_url?: string;
  trigger?: string;
  created_at: string;
  analytics: {
    phone_conversions: number;
    email_conversions: number;
    engagements: number;
    impressions: number;
  };
  schedule?: {
    id: number;
    action: 'ENABLE' | 'DISABLE';
    start_time: string;
    end_time: string | null;
  };
  split_test?: {
    split_test_id: number;
    type: string;
    weight: number;
  };
  auto_apply_offer_enabled: boolean | null;
  subscriber_cohort: string | null;
  new_subscriber_success_message: string | null;
  existing_subscriber_success_message: string | null;
}
interface PopupsResponse {
  total: number;
  data: Popup[];
}
type UsePopupsOptions = Partial<{
  name: string;
  limit: number;
  start: number;
  include_split_tests: string;
}>;

const getPopups = (options: UsePopupsOptions): Promise<PopupsResponse> => {
  const params = new URLSearchParams();
  Object.entries(options).forEach(([key, value]) => {
    if (value) {
      params.set(key, `${value}`);
    }
  });
  const url = `/v2/popups?${params.toString()}`;
  return api.get(url);
};

type UsePopups = {
  popups?: Popup[];
  total?: number;
} & Omit<UseQueryResult<PopupsResponse>, 'data'>;

export const usePopups = (options: UsePopupsOptions = {}): UsePopups => {
  const { data, ...rest } = useQuery({
    queryKey: ['popups', options],
    queryFn: () => getPopups({ include_split_tests: 'false', ...options }),
  });
  return { popups: data?.data, total: data?.total, ...rest };
};
